<template>
  <div class="rounded-lg border">
    <table class="w-full">
      <thead class="uppercase">
        <tr v-if="headers" :class="headerClass">
          <th v-for="(header, h) in headers" :key="h" :class="[...thClasses, header.class]">
            <slot :name="`header-${header.field}`" :item="header">
              {{ header.title }}
            </slot>
          </th>
        </tr>
      </thead>
      <tbody v-if="items">
        <tr v-for="(item, i) in items" :key="i" :class="bodyClass">
          <td v-for="(header, h) in headers" :key="h" :class="tdClass">
            <slot :name="header.field" :item="item">
              {{ getNestedProperty(item, header.field) ?? 'Não Atribuído' }}
            </slot>
          </td>
        </tr>
      </tbody>
    </table>

    <p class="text-center italic py-2 border-b" v-if="items.length < 1">Nenhum item a ser exibido.</p>

    <div :class="[{ 'py-1': !dense, 'py-0': dense }]">
      <NavigationBar
        v-model="currentPage"
        :disablePagination="disablePagination"
        :itemsPerPage="items.length"
        :limit="itemsPerPage"
        :totalItems="totalItems"
        :totalPages="totalPages" />
    </div>
  </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
// Props
const props = defineProps({
  dense: Boolean,
  disablePagination: Boolean,
  expanded: Boolean,
  headers: Array,
  items: Array,
  itemsPerPage: {
    type: Number,
    default: 10,
  },
  loader: Boolean,
  modelValue: Number,
  totalItems: Number,
  totalPages: Number,
})
// Emits
const emits = defineEmits(['update:modelValue', 'order'])
// Data
const currentPage = ref(1)
const orderField = ref({ field: '', tableOrder: '' })
// Computed
const headerClass = computed(() => {
  return 'border-b bg-[#f6f6f6]'
})
const thClasses = computed(() => {
  return ['text-left px-5', { 'py-3': !props.dense, 'py-0': props.dense }]
})
const bodyClass = computed(() => {
  return 'hover:bg-slate-50 border-b'
})
const tdClass = computed(() => {
  return ['px-5 ', { 'py-1': !props.dense, 'py-0': props.dense }]
})
// Métodos
const getNestedProperty = (obj, path) => {
  return path.split('.').reduce((acc, part) => acc && acc[part], obj)
}
// Watchers
watch(currentPage, (value) => {
  emits('update:modelValue', value)
})
watch(
  () => {
    return props.modelValue
  },
  (value) => {
    currentPage.value = value
  }
)
</script>
